// @flow
import React, { useEffect } from 'react';
import { Button } from 'semantic-ui-react';
import { infoLogger } from '../../helpers';
import ComviqContent from './ComviqContent';
import Header from 'views/Header';
import Error from 'views/Error';
import * as css from './ConfirmTele2.module.css';
import CardContainer from 'components/CardContainer';
import Footer from 'components/Footer';
import Card from 'components/Card';
import Loading from 'components';
import { useSelector } from 'react-redux';
import T2AppleWatch from './Tele2AppleWatch';
import SamsungWatchSvg from './SamsungWatchSvg';
import { getContentFor } from '../../helpers/contentHelpers';
import { isComviqCustomer, isAppleDevice } from '../../helpers/customerTypeHelpers';

type Props = {
  device?: string,
  onConfirm: () => void,
  isScrolled: boolean,
  hasAvailablePromotion?: boolean,
};

const Confirm = ({ device, onConfirm, isScrolled, hasAvailablePromotion }: Props) => {
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);
  const loading = useSelector((state) => state.app.isLoading);
  const error = useSelector((state) => state.app.error);
  const content = getContentFor(customerType);
  const confirmContent = content.page.confirm;
  let deviceInformation = device;
  let deviceName;
  let deviceType;

  if (device) {
    deviceInformation = deviceInformation.split(' ');
    const sliceLenght = deviceInformation.length - 1;
    deviceName = deviceInformation.slice(-sliceLenght).join(' ');
    deviceType = deviceInformation.slice(0, 1);
    deviceType = deviceType.join(' ');
  }

  const handleConfirmButton = () => {
    onConfirm(true);
  };

  useEffect(() => {
    window.__PAGE__ = 'Confirm';
    infoLogger({ name: 'client-page-view-confirm', log: 'Confirm device page shown' });
  }, []);

  if (loading) return <Loading />;
  if (error) return <Error message={error.message} />;

  if (!css) return <Loading />;
  return (
    <>
      {isComviq ? (
        <ComviqContent
          content={content}
          deviceType={deviceType}
          deviceName={deviceName}
          onConfirm={handleConfirmButton}
          hasAvailablePromotion={hasAvailablePromotion}
        />
      ) : (
        <>
          <Header />
          <CardContainer isComviq={false}>
            <Card as="main" id="card" isComviq={false}>
              <h2 className={css.title}>{confirmContent.title}</h2>
              <div>
                {isAppleDevice() ? <T2AppleWatch className={css.icon} /> : <SamsungWatchSvg className={css.icon} />}
                <div>
                  <p className={css.deviceName}>{deviceName}</p>
                  <p className={css.deviceType}>{deviceType}</p>
                </div>
              </div>
              <Footer isScrolled={isScrolled} isComviq={false}>
                <Button color="blue" primary fluid onClick={handleConfirmButton}>
                  {confirmContent.button}
                </Button>
              </Footer>
            </Card>
          </CardContainer>
        </>
      )}
    </>
  );
};

export default Confirm;
